import React, { useContext } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { Divider } from '@vio/atlas/Divider';
import { Box } from '@vio/atlas/helpers/Box';
import { HotelCardContext } from 'components/HotelCardContext';
import { PriceDifferenceAlert } from 'components/PriceDifferenceAlert';
interface Props {
  /** Callback fired when clicking on the card */
  onClick?: (e: React.SyntheticEvent) => void;
  /** The component to render for the gallery */
  gallerySlot: React.ReactNode;
  /** The component to render for the watch button */
  watchButtonSlot: React.ReactNode;
  /** The component to render for the property details */
  propertySummarySlot: React.ReactNode;
  /** The component to render extra property details details */
  basicPropertyDetailsSlot: React.ReactNode;
  /** The component to render if there are matching filters */
  filtersMatchSlot?: React.ReactNode;
  /** The component to render offers */
  offersSlot?: React.ReactNode;
  /** Is the top offer member deal */
  isTopOfferMemberDeal: boolean;
  /** Will add a border to highlight the anchor */
  isAnchor?: boolean;
  /** Compact hotel card when dates are UA  */
  isCompactHotelCard?: boolean;
  // Added as part of 366b54ed-price-difference-alert-meta-traffic
  showPriceDifferenceAlert?: boolean;
}
export const TOP_SECTION_MIN_HEIGHT = 182;
const COMPACT_CARD_MIN_HEIGHT = 134;
export const GALLERY_WIDTH = 128;
const TopSection = /*#__PURE__*/styled('section')({
  name: "TopSection",
  class: "tit1z4a",
  propsAsIs: false
});

/**
 * Pure presentational component for the base layout of the mobile hotel card
 * Do NOT access any context/store from here.
 */
const HotelCardLayoutComponent = ({
  onClick,
  gallerySlot,
  basicPropertyDetailsSlot,
  propertySummarySlot,
  watchButtonSlot,
  filtersMatchSlot,
  offersSlot,
  isTopOfferMemberDeal,
  isAnchor = false,
  isCompactHotelCard = false,
  showPriceDifferenceAlert = false
}: Props) => {
  const {
    hotelId
  } = useContext(HotelCardContext);
  return <Box backgroundColor="background.neutral.c000" borderRadius="md" {...isAnchor && {
    minHeight: `${COMPACT_CARD_MIN_HEIGHT}px`,
    outlineWidth: 's100',
    outlineOffset: '-1px',
    outlineStyle: 'solid',
    outlineColor: isCompactHotelCard ? 'border.neutral.c100' : 'hotelCard.special.border'
  }}>
      <TopSection className={cx(isCompactHotelCard && '__compactHotelCard', !isCompactHotelCard && isTopOfferMemberDeal && '__topOfferMemberDeal')}>
        {showPriceDifferenceAlert && <PriceDifferenceAlert />}
        <div role="button" tabIndex={0} onClick={onClick} onKeyDown={onClick} id={`HotelCard-${hotelId}`}>
          <Box display="flex" position="relative" minHeight={`${isCompactHotelCard ? COMPACT_CARD_MIN_HEIGHT : TOP_SECTION_MIN_HEIGHT}px`}>
            <Box width={`${GALLERY_WIDTH}px`}>{gallerySlot}</Box>
            <Box overflow="hidden" paddingTop="s400" paddingBottom="s300" paddingLeft="s300" paddingRight="s300" width="100%">
              {propertySummarySlot}
            </Box>
            <Box position="absolute" left="7px" top="7px" zIndex="1">
              {watchButtonSlot}
            </Box>
          </Box>

          {basicPropertyDetailsSlot && <>
              <Divider />
              {basicPropertyDetailsSlot}
            </>}

          {filtersMatchSlot && <>{filtersMatchSlot}</>}
        </div>
      </TopSection>

      {offersSlot}
    </Box>;
};
export const HotelCardLayout = React.memo(HotelCardLayoutComponent);

require("./HotelCardLayout.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./HotelCardLayout.tsx");